export default __webpack_public_path__ + "static/image 51-80feaa93b36b0e032c366ce6056948cb.png";